import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, IconButton, Typography, useTheme } from "@mui/material";
import { colCenter } from "@ui/style/style";
export const DirectorsInvitationStatCard = ({ Icon, title, value, active = false, onClick, clickable = false }) => {
    const theme = useTheme();
    return (_jsxs(Box, { onClick: clickable ? onClick : undefined, sx: {
            position: "relative",
            borderRadius: 2.5,
            px: 2.5,
            py: 2,
            height: "100%",
            boxShadow: " 0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33",
            backdropFilter: "lur(20px)",
            background: active ? theme.palette.primary.main : "white",
            cursor: 'pointer',
            '&:hover': {
                boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.2)',
            }
        }, children: [_jsxs(Box, { sx: { ...colCenter, gap: 1, mb: 1 }, children: [_jsx(IconButton, { size: "Xs", style: {
                            background: active
                                ? "transparent"
                                : alpha(theme.palette.primary.dark, 0.08),
                            color: active ? "white" : theme.palette.text.primary,
                        }, children: Icon }), _jsx(Typography, { variant: "subtitle2", fontWeight: 600, color: active ? "white" : "text.primary", noWrap: true, sx: {
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            maxWidth: '100%'
                        }, children: title })] }), _jsx(Typography, { variant: "h3", color: active ? "white" : "text.primary", children: value ? value : 0 })] }));
};
